import React from 'react'
import Link from 'gatsby-link'
import Social from './Social'
import styles from './FooterNew.module.scss';

const FooterNew = () => (
  <div className={`footer-new ${styles.Footer}`} id="site-footer">
    <div className="footer-wrap">
      <div className="footer-top">
        <div>
          <img className="footer-logo" src="/images/redesign/global-citizen-year-new-logo.svg" alt="
          Global Citizen Year logo" />
        </div>
        <div>
              <div className="menu-head">Fellowship</div>
              <Link to="/fellowship/">Overview</Link>
              <Link to="/experience/fellowship-experience/">Experience</Link>
              <Link to="/destinations-overview/">Destinations</Link>
              <Link to="/fellow-stories/">Fellowship Stories</Link>
              <Link to="/fellowship-faq/">FAQ</Link>
        </div>
        <div>
              <div className="menu-head">Academy</div>
              <Link to="/academy/">Overview</Link>
              <Link to="/experience/academy-experience/">Experience</Link>
              <Link to="/academy/speakers/">Meet the Speakers</Link>
              <Link to="/academy-stories/">Academy Stories</Link>
              <Link to="/academy-faq/">FAQ</Link>
        </div>
        <div>
              <div className="menu-head">Admissions</div>
              <Link to="/admissions/">Admissions & Tuition</Link>
              <Link to="/financial-aid-tuition/">Scholarships</Link>
              <Link to="/what-about-college/">What About College</Link>
              <Link to="/gap-year-resources/">Gap Year Resources</Link>
        </div>
        <div>
              <div className="menu-head">About Us</div>
              <Link to="/donate/">Donate</Link>
              <Link to="/about-us">Our Story</Link>
              <Link to="/our-impact/">Our Impact</Link>
              <Link to="/our-team/">Our Team</Link>
              <Link to="/press/">News & Press</Link>
        </div>
        <div>
              <div className="menu-head hide-mobile"></div>
              <Link to="/for-educators/">For Educators</Link>
              <Link to="/parents/">For Parents</Link>
              <Link to="/partners-and-supporters/">Partners & Supporters</Link>
              <Link to="/careers/">Careers</Link>
        </div>
       {/* <div>
              <Link to="/partners-and-supporters/">Partners & Supporters</Link>
              <Link to="/gap-year-resources/">Gap Year Resources</Link>
              <a href="https://www.zazzle.com/store/globalcitizenyear" target="_blank">Store</a>
              <Link to="/donate/">Donate</Link>
        </div>*/}
      </div>
      <div className="footer-bottom">
        <div className={styles.Footer__Left}>
            <p>1625 Clay Street, Suite 400, Oakland, CA 94612 <br />
            <a href="mailto:info@globalcitizenyear.org">info@globalcitizenyear.org</a><br/>
            <a href="tel:4159639293">415-963-9293</a><br/>
            Press Inquiries: Please contact Molly Weissman<br/>
            at <a href="tel:9174391442">917-439-1442</a> or <a href="mailto:molly@globalcitizenyear.org">molly@globalcitizenyear.org</a></p>
        </div>
        <div>
          <Social />
          <div className={`footer-sublinks ${styles.Footer__Nav}`}>
            <div>
                <a href="https://www.zazzle.com/store/globalcitizenyear" target="_blank">Store</a>
                <Link to="/privacy-policy/">Privacy Policy</Link>
            </div>
            <p>&copy; 2020 - Global Citizen Year</p>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default FooterNew



// WEBPACK FOOTER //
// ./src/components/Footer/FooterNew.js